/**
 * Сократить строку до заданной длины (с удалением пробелов и знаков припинания на конце)
 *
 * @param {string} str Заданная строка
 * @param {number} length Кол-во символов
 * @param {symbol} symbol подставляемые в окончание символы (по умолчанию троеточие)
 *
 * @return {string}
 *
 * @example cutStringTo('String!', 6) => 'Str...';
 * @example cutStringTo('npm WARN enoent SK!', 7, '&-') => 'npm W&-';
 */

export const cutStringTo = (str: string, length?: number, symbol = '...') => {
	function cut(str: string, length: number, symbolToPastle = symbol): string {
		const regExpression = /[.,\/#!$%\^&\*;:{}=\-_`~()\s]/g;
		let cutLength: number;
		let stringToCut: string = str.toString().trim();

		if (!length || length > stringToCut.length) {
			return stringToCut;
		} else if (length - symbolToPastle.length > 0) {
			cutLength = length - symbolToPastle.length;
		} else {
			cutLength = 1;
		}

		stringToCut = str.substring(0, cutLength);

		if (regExpression.test(stringToCut[stringToCut.length - 1]) && stringToCut.length > 1) {
			return cut(stringToCut, stringToCut.length - 1);
		}

		return stringToCut + symbolToPastle;
	}

	return cut(str, length, symbol);
};
